// Canvas v2 selection. Mutates `v2.selection` in place; chrome
// (selection box, handles, navbar) is updated imperatively via
// `refreshCanvasChrome` in the CanvasEditor overlay. Item DOM also
// gets `data-selected="1"` toggled for any item-local styling hooks.

function applyItemSelectedAttr(el, prevIds, nextIds, primary) {
  const items = el.getRoot?.()?.lookdown?.('CvItems')
  if (!items) return
  const prev = new Set(prevIds)
  const next = new Set(nextIds)
  for (const child of Object.values(items)) {
    const k = child?.state?.key
    if (!k) continue
    const was = prev.has(k); const is = next.has(k)
    if (was === is) {
      // Primary may have changed even if membership didn't.
      if (is && child.update) child.update({ attr: { 'data-selected': k === primary ? 'primary' : '1' } })
      continue
    }
    child.update?.({ attr: { 'data-selected': is ? (k === primary ? 'primary' : '1') : null } })
  }
}

function setSel(el, ids, primary) {
  const v2 = el.call('getCanvasV2'); if (!v2) return
  const prev = v2.selection.ids
  const nextIds = Array.from(new Set(ids))
  const nextPrimary = primary ?? (nextIds.length ? nextIds[nextIds.length - 1] : null)
  v2.selection = { ids: nextIds, primary: nextPrimary }
  applyItemSelectedAttr(el, prev, nextIds, nextPrimary)
  // Mirror to v1 scope for legacy chrome.
  const scope = el.call('getCanvasScope')
  if (scope) scope.selectedKey = nextPrimary
  el.call('refreshCanvasChrome')
  el.call('syncCanvas')
}

export function selectOne(key) { setSel(this, key ? [key] : [], key || null) }
export function toggleSelection(key) {
  const v2 = this.call('getCanvasV2'); if (!v2 || !key) return
  const present = v2.selection.ids.includes(key)
  const next = present
    ? v2.selection.ids.filter((k) => k !== key)
    : [...v2.selection.ids, key]
  setSel(this, next, present ? null : key)
}
export function selectMany(keys) { setSel(this, keys || [], null) }
export function clearSelection() { setSel(this, [], null) }
export function isSelected(key) { return !!this.call('getCanvasV2')?.selection?.ids?.includes(key) }
